import { useAppSelector } from '@app/hooks';
import { Pagination } from '@components/pagination';
import { selectOrdersCount } from '@modules/orders';

export const OrdersPagePagination = () => {
    const totalCount = useAppSelector(selectOrdersCount);
    return <Pagination totalCount={totalCount} wrap />;
};
